<template>
	<div class="render-form" :style="{ width: inputWidth }">
		<!-- 输入框 -->
		<el-input
			v-if="type === 'input'"
			class="render-form-input"
			:class="customClass"
			:size="size"
			:placeholder="placeholder || $t('inputKeywordsSearch')"
			clearable
			@keyup.enter.native="handleSearch"
			v-bind="$attrs"
			v-on="$listeners"
			@clear="handleSearch"
		>
			<i slot="suffix" class="el-input__icon el-icon-search icon_search" @click="handleSearch"></i>
		</el-input>
		<!-- 下拉单选 -->
		<el-select
			v-else-if="type === 'picker'"
			class="render-form-input"
			:class="customClass"
			:size="size"
			:placeholder="placeholder || $t('pleaseSelect')"
			@change="handleSearch"
			clearable
			v-bind="$attrs"
			v-on="$listeners"
		>
			<el-option
				v-for="(item, index) in options"
				:key="index"
				:label="item[labelKey || 'label']"
				:value="item[valueKey || 'value']"
			/>
		</el-select>
		<!-- 树结构下拉 -->
		<el-cascader
			class="render-form-input"
			:class="customClass"
			clearable
			:size="size"
			:placeholder="placeholder || $t('pleaseSelect')"
			v-else-if="type === 'cascader'"
			:options="options"
			@change="handleSearch"
			:style="{ width: inputWidth }"
			v-bind="$attrs"
			v-on="$listeners"
		/>
		<!-- 时间月份筛选 -->
		<el-date-picker
			v-else-if="type === 'daterange'"
			class="render-form-date"
			:style="{ width: inputWidth }"
			:size="size"
			type="daterange"
			:range-separator="$t('to')"
			:start-placeholder="placeholder ? placeholder[0] : $t('startDate')"
			:end-placeholder="placeholder ? placeholder[1] : $t('endDate')"
			:class="customClass"
			value-format="yyyy-MM-dd"
			@change="handleSearch"
			v-bind="$attrs"
			v-on="$listeners"
		/>
		<!-- 年月日 -->
		<el-date-picker
			v-else-if="type === 'date'"
			class="render-form-date"
			:size="size"
			:style="{ width: inputWidth }"
			type="daterange"
			:range-separator="$t('to')"
			:start-placeholder="placeholder ? placeholder[0] : $t('startTime')"
			:end-placeholder="placeholder ? placeholder[1] : $t('endTime')"
			:class="customClass"
			value-format="yyyy-MM-dd"
			@change="handleSearch"
			v-bind="$attrs"
			v-on="$listeners"
		/>
		<!-- 单个时间 -->
		<el-date-picker
			class="render-form-date"
			v-else-if="type === 'datepicker'"
			:style="{ width: inputWidth }"
			value-format="yyyy-MM-dd"
			:size="size"
			type="date"
			:class="customClass"
			:placeholder="placeholder || $t('pleaseSelectTime')"
			@change="handleSearch"
			v-bind="$attrs"
			v-on="$listeners"
		/>
		<!-- 月份选择器 -->
		<el-date-picker
			class="render-form-date"
			v-else-if="type === 'month'"
			:style="{ width: inputWidth }"
			value-format="yyyy-MM"
			:size="size"
			type="month"
			:class="customClass"
			:placeholder="placeholder || $t('pleaseSelectTime')"
			@change="handleSearch"
			v-bind="$attrs"
			v-on="$listeners"
		/>

		<!--月份范围  -->
		<el-date-picker
			class="render-form-date"
			v-else-if="type === 'monthRange'"
			:style="{ width: inputWidth }"
			value-format="yyyy-MM"
			:size="size"
			type="monthrange"
			:class="customClass"
			:placeholder="placeholder || $t('pleaseSelectTime')"
			:range-separator="$attrs.rangeSeparator || $t('to')"
			:start-placeholder="$attrs.startPlaceholder || $t('startMonth')"
			:end-placeholder="$attrs.endPlaceholder || $t('endMonth')"
			@change="handleSearch"
			v-bind="$attrs"
			v-on="$listeners"
		/>

		<!-- 批量 -->
		<batch-query-input
			v-else-if="type === 'batchInput'"
			:size="size"
			:width="inputWidth"
			:placeholder="placeholder || $t('inputKeywordsSearch')"
			v-bind="$attrs"
			v-on="$listeners"
		/>

		<select-and-dataPicker
			v-else-if="type === 'selectAndDataPicker'"
			:options="options"
			:label-key="labelKey"
			:value-key="valueKey"
			:select-config="{
				clearable: true,
				collapseTags: true,
				...$attrs.selectConfig
			}"
			v-bind="$attrs"
			v-on="{ ...$listeners, 'date-change': handleSearch }"
		/>
	</div>
</template>

<script>
import SelectAndDataPicker from "./SelectAndDataPicker.vue";
import BatchQueryInput from "@/components/BatchQueryInput";

export default {
	name: "RenderForm",
	components: {
		BatchQueryInput,
		SelectAndDataPicker
	},
	inheritAttrs: false,
	props: {
		/**
		 * 筛选类型
		 * input输入框
		 * picker下拉选择
		 * cascader级联选择
		 * daterange时间范围选择
		 * date时间选择
		 * datepicker日期选择
		 * batchInput批量输入
		 */
		type: {
			type: String,
			default: "input"
		},
		/**
		 * labelKey: 下拉选择label字段，默认label
		 */
		labelKey: {
			type: String,
			default: "label"
		},
		/**
		 * valueKey: 下拉选择value字段，默认value
		 */
		valueKey: {
			type: String,
			default: "value"
		},
		/**
		 * 输入框占位符
		 */
		placeholder: {
			type: [String, Array]
		},
		/**
		 * 输入框尺寸
		 */
		size: {
			type: String,
			default: "small"
		},
		/**
		 * 自定义class
		 */
		customClass: {
			type: String
		},
		/**
		 * 下拉选择options
		 */
		options: {
			type: Array,
			default: () => []
		},
		/**
		 * 输入框宽度，默认100%
		 */
		inputWidth: {
			type: String,
			default: "100%"
		}
	},
	methods: {
		handleSearch(value) {
			this.$emit("search", value);
		}
	}
};
</script>

<style lang="scss" scoped>
.render-form {
	box-sizing: border-box;

	&-input {
		width: 100%;

		::v-deep .el-cascader__search-input {
			font-size: inherit;
		}
	}

	&-date {
		width: 100%;
	}

	::v-deep .el-input__suffix-inner {
		display: flex;
		flex-direction: row-reverse;
	}

	::v-deep .el-input--suffix .el-input__inner {
		padding-right: 55px;
	}
}
</style>
